import React, { useEffect, useState } from 'react'
import { FaCar, FaGraduationCap, FaUser } from "react-icons/fa";
import { CATEGORY, endpoints } from '../../api/endpoints';
import Api_Instance from '../../api/Api_Instance';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setBanner, setBanner_id } from '../../redux/slice/Slice';
function Category({ onClose, isSticky }) {
    const api = Api_Instance.unAuth();
    const dispatch = useDispatch();
    const [categorydata, setCategoryData] = useState([]);
    const cateGoryApi = async () => {
        try {
            const res = await api("GET", CATEGORY.GET_CATEGORY);
            setCategoryData(res?.data?.data);
            // dispatch(setBanner_id(res?.data?.data?.slice(0,1)))
        } catch (error) { }
    };
    const handleChange = async (id) => {
        try {
            const res = await api("GET", endpoints.BUSSINESS_API, null, { category: id });
            dispatch(setBanner(res?.data?.data));
            onClose();
        } catch (error) {

        }
    }

    useEffect(() => {
        cateGoryApi()

    }, [])
    console.log(isSticky,'isSticky')
    return (
        categorydata?.length > 0 ?
            <div className="w-full max-w-[1250px] mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
                <div className={`flex w-56 ${isSticky ? "fixed top-[40px] z-[999]" : "absolute z-10 top-[180px] max-sm:w-full max-sm:top-[130px]"}`} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                    <div class="py-1 max-sm:w-full" role="none">
                        <div className="border-[#D9D9D9] border rounded-[10px] p-[20px] bg-[#FAFAFA] mt-[10px] h-[450px] overflow-auto max-sm:w-[90%]">
                            {categorydata?.map((item) => (
                                <div className="flex items-center gap-3 mb-[10px] cursor-pointer">
                                    <img src={item?.icon} className="text-[#4A5661] w-[20px]" alt='icon' />
                                    <Link to="/" className="text-[#4A5661] 2xl:text-[16px] text-[14px] font-medium" role="menuitem" tabindex="-1" id="menu-item-0" onClick={() => handleChange(item.id)}> {item?.name}</Link>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div> : <></>
    )
}

export default Category